import React from 'react';

import HomePage from './components/homepage'

class App extends React.Component {

  render() {
    return (
      <HomePage {...this.props}/>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js